var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`header-v${_vm.content.variant || 1}`,{tag:"component",attrs:{"content":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }